/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {useQueryResponseLoading, useQueryResponsePagination} from '../../core/QueryResponseProvider'
import {useQueryRequest} from '../../core/QueryRequestProvider'

const mappedLabel = (label: string): string => {
  if (label === '&laquo; Previous') {
    return 'Previous'
  }

  if (label === 'Next &raquo;') {
    return 'Next'
  }

  return label
}

const UsersListPagination = ({
  page,
  setPage,
  totalPages,
  loading,
  paginationDetails,
  onRefresh,
}: any) => {
  const pagination = useQueryResponsePagination()
  const isLoading = useQueryResponseLoading()
  const {updateState} = useQueryRequest()

  const updatePage = (page: number | null) => {
    if (!page || isLoading || pagination.page === page) {
      return
    }

    updateState({page, items_per_page: pagination.items_per_page || 10})
  }

  // Safe page navigation functions
  const goToPage = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalPages) {
      if (newPage === page && onRefresh) {
        // If clicking on the same page, trigger a refresh
        console.log('Same page clicked, triggering refresh...')
        onRefresh()
      } else {
        // Set the page normally
        setPage(newPage)
      }
    }
  }

  const goToPrevious = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const goToNext = () => {
    if (page < totalPages) {
      setPage(page + 1)
    }
  }

  let startPage = Math.max(1, page - 3)
  let endPage = Math.min(totalPages, page + 3)
  let pages = []

  // Add previous 3 pages
  if (page - 3 > 1) {
    for (let i = startPage; i < page; i++) {
      pages.push(i)
    }
  } else {
    for (let i = 1; i < page; i++) {
      pages.push(i)
    }
  }

  // Add current page
  pages.push(page)

  // Add next 3 pages
  if (page + 3 < totalPages) {
    for (let i = page + 1; i <= endPage; i++) {
      pages.push(i)
    }
  } else {
    for (let i = page + 1; i <= totalPages; i++) {
      pages.push(i)
    }
  }

  return (
    <div className='row'>
      <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>
      <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
        <div id='kt_table_users_paginate'>
          <ul className='pagination'>
            <li
              className={clsx('page-item', {
                disabled: loading || page <= 1,
                previous: !loading && page > 1,
              })}
            >
              <a
                className={clsx('page-link', {})}
                onClick={goToPrevious}
                style={{cursor: page > 1 ? 'pointer' : 'not-allowed'}}
              >
                {mappedLabel('Previous')}
              </a>
            </li>

            {pages.map((item) => (
              <li
                key={item}
                className={clsx('page-item', {
                  active: item === page,
                })}
              >
                <a
                  className={clsx('page-link', {})}
                  onClick={() => goToPage(item)}
                  style={{cursor: 'pointer'}}
                >
                  {item}
                </a>
              </li>
            ))}

            <li
              className={clsx('page-item', {
                disabled: loading || page >= totalPages,
                next: !loading && page < totalPages,
              })}
            >
              <a
                className={clsx('page-link', {})}
                onClick={goToNext}
                style={{cursor: page < totalPages ? 'pointer' : 'not-allowed'}}
              >
                {mappedLabel('Next')}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export {UsersListPagination}
